import EndUserManagement from "@/components/Dashboard/Users/EndUserManagement/EndUserManagement.vue";
import endUserManagementDetail from "@/components/Dashboard/Users/EndUserManagement/EndUserManagementDetails.vue";

const endUserManagementRoutes = [ 
    {
        path: "endUserManagements",
        component: EndUserManagement,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "EndUserManagement",
    },
    {
        path: "endUserManagement/:id",
        component: endUserManagementDetail,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "EndUserManagementDetails",
    },
]

export default endUserManagementRoutes;